import { gql } from "@apollo/client";

export const PERSON = gql`
    query queryPerson($id: Float!) {
        person(id: $id) {
            id
            name
            city
            region
            cpf
            rg
            age
            birth_date
            sorting {
                id
                respiratory_frequency
                heart_rate
                notes
                temperature
                imc
                weight
                pressure
                saturation
                height
            }
            call {
                id
                diagnosis
                anamnesis
                items
            }
            calls {
                id
                mission {
                    id
                    name
                    start_date
                    end_date
                }
                sorting {
                    id
                    respiratory_frequency
                    heart_rate
                    notes
                    temperature
                    imc
                    weight
                    pressure
                    saturation
                    height
                }
                diagnosis
                anamnesis
                user {
                    name
                }
                items
            }
        }
        medicines {
            id
            name
            stock
            need
            box
        }
    }
`;

export const PEOPLE = gql`
    query queryPeople {
        people {
            id
            name
            city
            region
            cpf
            rg
            age
            birth_date
            call {
                id
            }
        }
    }
`;

export default PERSON;
